import i18n from '@/i18n';
import {graphqlClient} from '@/services/graphqlClient';
import type {GetAllUsersForExportQuery} from '@/services/graphqlHooks';
import {useGetAllUsersForExportQuery, UserGroup} from '@/services/graphqlHooks';
import queryClient from '@/services/queryClient';
import userGroups from '@/translation/userGroups';

import type {ExportDefinition} from '../../types/exportTypes';
import {formatPersonName, noOptions} from '../exportOptions';

type UserExportRecord = GetAllUsersForExportQuery['getAllUsers'][number];

export const usersExport: ExportDefinition<
  Record<string, never>,
  UserExportRecord
> = {
  id: 'users',
  label: i18n.t('Users'),
  permission: 'EXPORT_USERS',
  entitlement: 'USERS',
  ...noOptions,
  load: async () => {
    const {getAllUsers} = await queryClient.fetchQuery({
      queryKey: useGetAllUsersForExportQuery.getKey(),
      queryFn: useGetAllUsersForExportQuery.fetcher(graphqlClient),
    });

    return getAllUsers.filter(
      user => user.group !== UserGroup.AuthorizedRelatives
    );
  },
  columns: [
    {header: i18n.t('Name'), value: user => formatPersonName(user.name)},
    {header: i18n.t('Username'), value: user => user.userName},
    {header: i18n.t('Personal number'), value: user => user.personalNumber},
    {
      header: i18n.t('Group'),
      filterable: true,
      value: user => userGroups[user.group],
    },
  ],
  getFileName: () => 'users',
};
